import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import CurriculumEnrollments from "./CurriculumEnrollments";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-curriculum-enrollments")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<CurriculumEnrollments />
		</ThemeProvider>
	</StrictMode>
);
